<template>
    <div>
        <div class="table-box">
            <div class="search-box">
                <Button type="primary" @click="addTeacherModal=true;resetForm('addTeacherForm')">新增教师</Button>
            </div>
            <Table  :columns="columns" :data="all_teacher.body"></Table>
            <div  class="page-box" v-if="all_teacher.page">
                <Page show-sizer
                      show-total
                      :page-size="all_teacher.page.page_size"
                      :current="all_teacher.page.current"
                      :total="all_teacher.page.count"
                      @on-change="currentPage"
                      @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <Modal
                v-model="addTeacherModal"
                title="新增教师"
                width="420"
                :loading="loading"
                :mask-closable="false"
                @on-ok="add('addTeacherForm')"
        >
            <div>
                <Form :model="addTeacherForm" :rules="addValidate" :label-width="100" ref="addTeacherForm" >
                    <FormItem label="教师名称" style="margin-bottom: 10px"  prop="nickname">
                        <Input v-model="addTeacherForm.nickname" placeholder="请输入教师名称" style="width: 240px"></Input>
                    </FormItem>
                    <br />
                    <FormItem label="教师账号" style="margin-bottom: 10px" prop="username">
                        <Input v-model="addTeacherForm.username" placeholder="请输入教师账号" style="width: 240px">
                            <span slot="append">@{{user_info.schoolDomain}}</span>
                        </Input>
                    </FormItem>
                    <br />
                    <FormItem label="密码" style="margin-bottom: 10px" prop="password">
                        <Input v-model="addTeacherForm.password" placeholder="请输入创建密码" style="width: 240px" type="password"></Input>
                    </FormItem>
                    <br />
                    <FormItem label="关联学院" style="margin-bottom: 10px" prop="organId">
                        <Select v-model="addTeacherForm.organId"  style="width: 240px">
                            <Option :value="item.college_id" v-for="(item,idx) in colleges_info" :key="idx">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <br />
                    <FormItem label="是否禁用" >
                        <i-switch size="large" v-model="addTeacherForm.enabled">
                            <span slot="open" :value="true">启用</span>
                            <span slot="close" :value="false">禁用</span>
                        </i-switch>
                    </FormItem>
                </Form>
            </div>
        </Modal>
        <Modal
                v-model="editTeacherModal"
                title="编辑教师"
                width="420"
                :loading="loading"
                :mask-closable="false"
                @on-ok="edit('editForm')"
        >
            <div>
                <Form :model="editForm"  :label-width="100" :rules="editValidate" ref="editForm">
                    <FormItem label="教师账号" style="margin-bottom: 10px" prop="username">
                        <Input v-model="editForm.username" placeholder="请输入教师账号" style="width: 240px" disabled>
                        </Input>
                    </FormItem>
                    <FormItem label="教师名称" style="margin-bottom: 10px" prop="nickname">
                        <Input v-model="editForm.nickname" placeholder="请输入教师名称" style="width: 240px"></Input>
                    </FormItem><br />
                    <FormItem label="关联学院" style="margin-bottom: 10px" prop="organId">
                        <Select v-model="editForm.organId"  style="width: 240px" disabled>
                            <Option :value="item.college_id" v-for="(item,idx) in colleges_info" :key="idx">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="是否禁用" >
                        <i-switch size="large" v-model="editForm.enabled">
                            <span slot="open" :value="true">启用</span>
                            <span slot="close" :value="false">禁用</span>
                        </i-switch>
                    </FormItem>
                </Form>
            </div>
        </Modal>
    </div>
</template>

<script>
    import moment from "moment";
    import {mapActions, mapState} from "vuex";

    export default {
        name: "teacher",
        data(){
            const validateOrganId = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择关联学院！'));
                } else{
                    callback();
                }
            };
            // 教师名称校验
            const validateNickName = (rule,value,callback) =>{
                let reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
                if(value === ''){
                    callback(new Error('教师账号不能为空'));
                }else if(!reg.test(value)){
                    callback(new Error('用户名不能包含特殊字符'));
                }else{
                    callback();
                }
            };
            // 账号校验
            const validateName = (rule,value,callback) =>{
                let reg = /^\w{4,15}$/
                if(value === ''){
                    callback(new Error('账号不能为空'))
                }else if(!reg.test(value)){
                    callback(new Error('账号为4-15位英文字母下划线'));
                }else{
                    callback();
                }
            };
            //密码校验
            const validatePwd = (rule, value, callback) => {
                let reg = /(?=.*[0-9])(?=.*[a-zA-Z]).{6,20}/;
                if (value === '') {
                    callback(new Error('密码不能为空！'));
                } else if(!reg.test(value)){
                    callback(new Error('密码必须包含字母、数字的6-20位数！'));

                }else{
                    callback();
                }
            };
            return{
                addTeacherModal:false,
                editTeacherModal:false,
                teacher_id:null,
                loading:true,
                addTeacherForm:{
                    nickname:'',
                    username:'',
                    password:'',
                    organId:'',
                    enabled:true
                },
                editForm:{
                    nickname:'',
                    username:'',
                    organId:'',
                    enabled:true
                },
                columns: [
                    {
                        title:'ID',
                        key:'id',
                        width:65,
                        tooltip:true,
                        sortable: true
                    },
                    {
                        title:'教师账号',
                        key:'username'
                    },
                    {
                        title:'教师姓名',
                        key:'nickname'
                    },
                    {
                        title: '状态',
                        key: 'enabled',
                        width:120,
                        render: (h, params) => {
                            return h('div', [
                                h('Icon', {
                                    style: {
                                        marginRight: '5px',
                                        color:params.row.enabled ? '#42b983':'red'
                                    },
                                    props:{
                                        type:params.row.enabled?'md-checkmark-circle':'ios-close-circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.disableStu(params.row)
                                        }
                                    }
                                }, '禁用'),
                                h('span', {

                                }, params.row.enabled ? '启用':'禁用'),
                            ]);
                        }
                    },
                    {
                        title: '创建时间',
                        key: 'ctime',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                }, moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss')),
                            ]);
                        }
                    },
                    {
                        title: '更新时间',
                        key: 'mtime',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                }, moment(params.row.updateTime).format('YYYY-MM-DD HH:mm:ss')),
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.editCollegeRow(params.row)
                                        }
                                    }
                                }, '编辑'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.deleteTeacher(params.row)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                ],
                page_num:1,
                page_size:20,
                addValidate: {
                    nickname: [
                        {required: true, validator: validateNickName, trigger: 'blur'}
                    ],
                    username: [
                        {required: true, validator: validateName, trigger: 'blur'}
                    ],
                    password: [
                        {required: true, validator: validatePwd, trigger: 'blur'}
                    ],
                    organId:[
                        {required: true, validator: validateOrganId, trigger: 'change'}
                    ]
                },
                editValidate: {
                    nickname: [
                        {required: true, validator: validateNickName, trigger: 'blur'}
                    ],
                },
            }
        },
        computed: {
            ...mapState({
                all_teacher:state => state.colleges.all_teacher,
                colleges_info:state => state.colleges.colleges_info,
                user_info: state => state.loginState.user_info,
            }),
        },
        methods: {
            ...mapActions({
                getTeacher: 'colleges/getTeacher',
                addTeacher:'colleges/addTeacher',
                delTeacher:'colleges/delTeacher',
                editTeacher:'colleges/editTeacher',
                getColleges:'colleges/getColleges',
            }),
            changeLoading() {
                this.loading = false;
                this.$nextTick(() => {
                    this.loading = true;
                });
            },
            resetForm (name) {
                this.$refs[name].resetFields();
            },
            //新增学院
            add(name){
                let _this = this
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        _this.addTeacher({
                            data: _this.addTeacherForm,
                            callback: res => {
                                if (res.status.code === 2000000) {
                                    _this.$Message.success('新增教师成功')
                                    _this.initTeacher()
                                    _this.addTeacherModal = false
                                } else {
                                    _this.$Message.error(res.status.message)
                                    return this.changeLoading();
                                }
                            }
                        })
                    } else {
                         return this.changeLoading();
                    }
                })
            },
            edit(name){
                let _this = this
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        _this.editTeacher({
                            data:_this.editForm,
                            teacher_id:_this.teacher_id,
                            callback:res =>{
                                if(res.status.code === 2000000){
                                    _this.$Message.success('编辑教师成功')
                                    _this.editTeacherModal = false
                                    _this.initTeacher()
                                }else{
                                    _this.$Message.error(res.status.message)
                                    return this.changeLoading();
                                }

                            }
                        })
                    } else {
                        return this.changeLoading();
                    }
                })
            },
            editCollegeRow(row){
                this.editTeacherModal = true
                this.teacher_id = row.id,
                this.editForm.nickname = row.nickname
                this.editForm.username = row.username
                this.editForm.organId = row.organId
                this.editForm.enabled = row.enabled
            },
            //删除教师
            deleteTeacher(row){
                let _this = this
                this.$Modal.warning({
                    title: `删除教师${row.nickname}`,
                    content: '确认要删除此数据吗？删除后不可恢复！',
                    onOk:function(){
                        _this.delTeacher({
                            teacher_id:row.id,
                            callback:res =>{
                                _this.$Message.success('删除成功！')
                                _this.initTeacher()
                            }
                        })
                    }
                });
            },
            initTeacher(){
                let _this = this
                this.getTeacher({
                    page_num:_this.page_num,
                    page_size:_this.page_size
                })
            },
            currentPage(num){
                this.current = num
                this.initTeacher()
            },
            pageSizeChange(size){
                this.page_size = size
                this.initTeacher()
            },
        },
        mounted () {
            this.initTeacher()
            this.getColleges()
        },
    }
</script>

<style scoped lang="less">
    @import "../../style/index";
</style>
